import DOMPurify from 'dompurify';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import remarkRehype from 'remark-rehype';
import rehypeStringify from 'rehype-stringify';

const markdownProcessor = unified()
  .use(remarkParse)
  .use(remarkGfm)
  .use(remarkBreaks)
  .use(remarkRehype)
  .use(rehypeStringify);

export function markdownToHtml(markdown) {
  return String(markdownProcessor.processSync(markdown));
}

export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}

export function containsHtml(str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}

export function newLinesToHtml(str) {
  return str.replace(/\n/g, '<br>');
}
